import React from 'react';
import { Link } from 'react-router-dom';

function AboutPage() {
  return (
    <div className="page">
      <div className="page-header">
        <Link to="/" className="back-link">&larr;</Link>
        <h1>About This Project</h1>
      </div>

      <div className="card">
        <h3>What is AI Prize Wheel?</h3>
        <p className="text-muted">
          AI Prize Wheel is an interactive raffle and giveaway tool designed for live events.
          It provides a fun, visual way to run prize drawings with a spinning wheel interface
          that audiences can watch in real time.
        </p>
      </div>

      <div className="card">
        <h3>Why Was It Built?</h3>
        <p className="text-muted">
          Jordan dreamed up this project to solve a common problem: always needing a prize wheel
          at events without the overhead of having a developer build one from scratch each time.
          The result is a reusable, branded experience that keeps audiences engaged and excited
          during giveaways.
        </p>
      </div>

      <div className="card">
        <h3>Built with AI</h3>
        <p className="text-muted">
          This project was built using AI-powered development tools including Claude Code
          and GitHub Copilot. Development follows a project board workflow where items are
          triaged into sprints and completed through a combination of direct prompts and
          organized task management.
        </p>
      </div>

      <div className="card">
        <h3>How It Works</h3>
        <p className="text-muted">
          Admins create raffles with unique entry codes that can be shared via QR codes or
          direct links. Participants join by entering the code and their information. When
          it is time to draw winners, a spinning prize wheel selects participants at random
          using cryptographically secure randomness. The entire drawing can be presented
          live for audiences to watch.
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
